<template>
  <div>
  <b-card
        border-variant="secondary"
        header-bg-variant="secondary"
        header-text-variant="white"
        :header= "$t('propertyInfo.title')"
        align="center"
        style="max-width: 40rem;"
        class="mx-auto"
      >
      <b-card-title>{{this.$store.getters.getPropertyInfo.name}}</b-card-title>
      <b-card-sub-title class="text-dark">{{this.$store.getters.getPropertyInfo.address}}</b-card-sub-title>
      <b-card-text></b-card-text>
      <b-card-text class="text-dark" v-if="this.$store.getters.getPropertyInfo.managementName"><span class="font-weight-bold">{{$t('propertyInfo.contact')}} </span>{{this.$store.getters.getPropertyInfo.managementName}}</b-card-text>
      <b-card-text class="text-dark" v-if="this.$store.getters.getPropertyInfo.managementPhone" >
        <span class="font-weight-bold">{{$t('generic.phone')}}  </span>
        <a class="text-primary" v-bind:href="'tel:' + this.$store.getters.getPropertyInfo.managementPhone">{{this.$store.getters.getPropertyInfo.managementPhone }}</a>
      </b-card-text>
      <b-card-text class="text-dark" v-if="this.$store.getters.getPropertyInfo.managementEmail">
        <span class="font-weight-bold">{{$t('generic.email')}} </span>
        <a class="text-primary" v-bind:href="'mailto:' + this.$store.getters.getPropertyInfo.managementEmail">{{this.$store.getters.getPropertyInfo.managementEmail }}</a>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>

import store from "../store/store";

export default {
  name: 'PropertyInfo',
  async mounted () {
    await store.getters.getPropertyInfo
  }
}
</script>